import './index.erb';
import './index.rb';
import './index.scss';

class QuestionCourses {
  constructor($context) {
    this.$context = $context;
    this.init();
  }

  init() {
    this.$button = $('.button-card', this.$context);
    this.$button.on('click', () => {
      UserTracker.emit('event', {
        eventName: 'topic guide showcase clicked'
      });
    });
  }
}

(function ($) {
  'use strict';

  $(document)
    .off('componentLoaded:questions/question_courses')
    .on('componentLoaded:questions/question_courses', (e, data) => {
      new QuestionCourses(data.context);
    });
})(jQuery);
